import React, { useState, useEffect } from "react";
import styles from "./report.module.css";
import { ReportType } from "../../utils/utils";
import { useRoleFeature } from "../../context/RoleFeatureContext"; // Adjust path as needed

function Report() {
  const [activeTab, setActiveTab] = useState("report");
  const [selectedOption, setSelectedOption] = useState({
    report: ReportType.report[0],
    download: ReportType.download[0],
  });
  const { hasAccess } = useRoleFeature();
  const [downloadAccess, setDownloadAccess] = useState(false);

  useEffect(() => {
    setDownloadAccess(hasAccess("Download", "readAccess"));
  }, [hasAccess]);

  const handleTabClick = (tab) => {
    if (tab === "download" && !downloadAccess) return;
    setActiveTab(tab);
    setSelectedOption((prev) => ({
      ...prev,
      [tab]: ReportType[tab][0],
    }));
  };

  const handleOptionClick = (tab, option) => {
    setSelectedOption((prev) => ({
      ...prev,
      [tab]: option,
    }));
  };

  const activeComponent = selectedOption[activeTab]?.Component;

  return (
    <div className={styles.container}>
      <div className={styles.tabWrapper}>
        <div className={styles.tabList}>
          {["report", "download"].map((tab) => {
            if (tab === "download" && !downloadAccess) return null;
            return (
              <div
                key={tab}
                className={`${styles.tabItem} ${
                  activeTab === tab ? styles.activeTab : ""
                }`}
                onClick={() => handleTabClick(tab)}
                style={{ cursor: "pointer" }}
              >
                <div className={styles.tabName}>
                  {tab.charAt(0).toUpperCase() + tab.slice(1)}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      {activeComponent && React.createElement(activeComponent)}
    </div>
  );
}

export default Report;